export default __webpack_public_path__ + "static/media/superbowl.a45f09f4.png";